/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RelayConnectionInterface
 * @format
 */

'use strict';

module.exports = require('./RelayOSSConnectionInterface');


//////////////////
// WEBPACK FOOTER
// /~/react-relay/lib/RelayConnectionInterface.js
// module id = qer+
// module chunks = 0